<template>
  <section class="py-4">
    <v-container>
      <v-row align="center" justify="center">
        <v-col cols="12">
          <div class="text-center">
            <h3 class="text-h4 font-weight-light mb-3">How to earn Reward Points?</h3>
            <h4 class="text-body-1 mb-6">
              There are many ways to earn Reward Points:
            </h4>
          </div>
        </v-col>

        <v-col
          v-for="(item, index) in earningMethods"
          :key="index"
          cols="6"
          md="4"
          lg="3"
          xl="2"
        >
          <v-card outlined>
            <v-card-title>
              <div class="text-center w-100-percentage">
                <v-icon large class="mb-4">fal fa-{{ item.icon }}</v-icon>
                <span class="text-h6 font-weight-bold d-block">
                  {{ item.label }}
                </span>
              </div>
            </v-card-title>
            <v-card-text class="text-center">
              <div>
                <span class="font-weight-bold">
                  {{ item.info
                  }}<nuxt-link
                    v-if="item.link"
                    :to="item.link"
                    class="ml-2 no-underline"
                    ><v-icon small>fal fa-info-circle</v-icon></nuxt-link
                  >
                </span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12">
          <div class="text-center">
            Pro and Pro+ upgrades works only for yearly subscriptions
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'TokensEarning',
  data() {
    return {
      earningMethods: [
        {
          icon: 'fal fa-coins',
          label: 'Unused Tokens',
          info: '1 Token = 1 Reward Point',
          link: '/faq#what-are-photo-upload-tokens-and-how-do-i-earn-them'
        },
        {
          icon: 'share',
          label: 'Story mention',
          info: 'Up to 300 Reward Points',
          link: '/faq#how-can-i-earn-tokens-mentioning-100asa-on-ig-stories'
        },
        {
          icon: 'fal fa-star',
          label: 'Elite promotion',
          info: '200 Reward Points'
        },
        {
          icon: 'fal fa-lightbulb-on',
          label: 'Inspiration promotion',
          info: '100 Reward Points'
        },
        {
          icon: 'fas fa-images',
          label: 'Prime promotion',
          info: '50 Reward Points'
        },
        {
          icon: 'fas fa-rocket',
          label: 'Upgrade to Pro',
          info: '300 Reward Points'
        },
        {
          icon: 'fas fa-rocket-launch',
          label: 'Upgrade to Pro+',
          info: '500 Reward Points'
        }
      ]
    }
  }
}
</script>
